import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ShoppingBag, ChevronDown } from 'lucide-react';
import { motion } from 'framer-motion';
import './Hero.css';

const Hero = () => {
    return (
        <section className="hero">
            {/* Cinematic Background */}
            <div className="hero-bg">
                <img
                    src="https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?auto=format&fit=crop&q=80&w=1920"
                    alt="Sports Action Background"
                />
                <div className="hero-overlay"></div>
            </div>

            <div className="container relative z-10">
                <motion.div
                    className="hero-content"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                >
                    <motion.span
                        className="hero__eyebrow"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                    >
                        Empowering Youth Excellence Since 2023
                    </motion.span>

                    <motion.h1
                        className="hero-headline"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4 }}
                    >
                        Developing Zimbabwe's <br />
                        <span className="text-secondary">Next Generation</span> <br />
                        of Champions
                    </motion.h1>

                    <motion.p
                        className="hero-subheadline"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.6 }}
                    >
                        Elite sports training, youth empowerment, and competitive excellence in Harare.
                        Join the proven pathway to provincial and national selection with professional coaching and world-class facilities.
                    </motion.p>

                    <motion.div
                        className="hero-btns"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.8 }}
                    >
                        <a
                            href="https://wa.me/263781665264?text=Hi, I would like to enroll my child in Vision Sports Academy."
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary group"
                        >
                            Enroll Now
                            <ArrowRight size={20} className="ml-2 transition-transform group-hover:translate-x-1" />
                        </a>
                        <Link to="/shop" className="btn btn-outline group">
                            Visit Our Shop
                            <ShoppingBag size={20} className="ml-2" />
                        </Link>
                    </motion.div>
                </motion.div>
            </div>

            {/* Scroll Indicator */}
            <motion.div
                className="hero__scroll-indicator"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.2 }}
            >
                <span>Scroll to Explore</span>
                <ChevronDown size={24} />
            </motion.div>
        </section>
    );
};

export default Hero;
